// @flow
import * as React from 'react';
import type { RouterHistory } from 'react-router';
import algoliaSearch from 'utils/algoliaSearch';
import getVolopsSearchIndex from 'utils/search/getVolopsSearchIndex';
import type { CurrentUser } from 'api/currentUser';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import getSearchConfig from 'utils/search/getSearchConfig';
import { listingSearchHomePath } from 'utils/searchHomePages';
import type { RecommendedAction } from 'api/shared';
import type { RecommendedActionsBlockData } from 'api/cms';
import TileCarousel from 'components/TileCarousel';
import Box from 'components/Box';

const { useEffect, useState } = React;

const getActions = (currentUser: ?CurrentUser) => {
  const searchConfig = getSearchConfig();

  let locationOptions = {};
  if (
    currentUser &&
    currentUser.searchLocation &&
    currentUser.searchLocation.latitude &&
    currentUser.searchLocation.longitude
  ) {
    locationOptions = getSearchLocationOptions(
      'auto',
      currentUser.searchLocation
    ).locationOptions;
  }

  const queryOptions = {
    index: getVolopsSearchIndex(),
    filters: 'type:VOLOP AND source:IDEALIST',
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url'
    ],
    ...locationOptions
  };
  return algoliaSearch(searchConfig, '', queryOptions)
    .then(({ hits }) => hits)
    .catch();
};

const RecommendedActionsBlock = ({
  data: { headline },
  history
}: {
  data: RecommendedActionsBlockData,
  history: RouterHistory
}) => {
  const [recommendedActions, setRecommmendedActions] = useState([]);
  useEffect(() => {
    getActions().then((actions: Array<RecommendedAction>) => {
      setRecommmendedActions(actions);
    });
  }, []);

  return (
    <Box data-qa-id="recommended-actions">
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        history={history}
        seeAllText={
          /* TRANSLATORS: Link to actions search */ getText('See all Actions')
        }
        seeAllUrl={`${listingSearchHomePath('VOLOP')}`}
        listingType="ACTION"
      />
    </Box>
  );
};

export default RecommendedActionsBlock;
